import {client} from './services/client'

export  const user_means_paiements = {
    namespaced:true,
    state:{
        user_means_paiements:undefined,
        user_means_paiementinactifs:undefined,
        user_means_paiement_encours:undefined,
        user_means_paiement_confirms:undefined,
    },
    mutations: {
        SET_USER_MEANS_PAIEMENT (state,user_means_paiements){
            state.user_means_paiements = user_means_paiements
        },
        SET_USER_MEANS_ENCOURS (state,user_means_paiements){
            state.user_means_paiement_encours = user_means_paiements
        },
        SET_USER_MEANS_CONFIRM (state,user_means_paiements){
            state.user_means_paiement_confirms = user_means_paiements
        },
        SET_USER_MEANS_INACTIF (state,user_means_paiements){
            state.user_means_paiementinactifs = user_means_paiements
        },


    },
    actions: {
        getUser_means_paiements({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/get',
                    data:data
                })
                    .then((response)=>{
                        let user_means_paiements = response.data.user_means_paiements;
                        let user_means_paiementinactifs = response.data.user_means_paiementinactifs;
                        commit('SET_USER_MEANS_PAIEMENT',user_means_paiements)
                        commit('SET_USER_MEANS_INACTIF',user_means_paiementinactifs)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getUser_means_paiementConfirmations({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiement_confirmations/get',
                    data:data
                }).then((response)=>{
                        let user_means_paiements = response.data.user_means_paiements;
                        let state = response.data.state;
                        if (state) {
                            commit('SET_USER_MEANS_CONFIRM',user_means_paiements)
                        }else{
                            commit('SET_USER_MEANS_ENCOURS',user_means_paiements)
                        }
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getUser_means_paiementsBytype({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/by_type/get',
                    data:data
                })
                    .then((response)=>{
                        let user_means_paiements = response.data.user_means_paiements;
                        commit('SET_USER_MEANS_PAIEMENT',user_means_paiements)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setUpdateUser_means_paiement({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/update',
                    data:data,
                })
                    .then((response)=>{
                      let user_means_paiements = response.data.user_means_paiements;
                      let user_means_paiementinactifs = response.data.user_means_paiementinactifs;
                      commit('SET_USER_MEANS_PAIEMENT',user_means_paiements)
                      commit('SET_USER_MEANS_INACTIF',user_means_paiementinactifs)

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUser_means_paiement({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/save',
                    data:data,
                })
                    .then((response)=>{
                      let user_means_paiements = response.data.user_means_paiements;
                      let user_means_paiementinactifs = response.data.user_means_paiementinactifs;
                      commit('SET_USER_MEANS_PAIEMENT',user_means_paiements)
                      commit('SET_USER_MEANS_INACTIF',user_means_paiementinactifs)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteUser_means_paiements({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/delete',
                    data:data

                })
                    .then((response)=>{
                      let user_means_paiements = response.data.user_means_paiements;
                      let user_means_paiementinactifs = response.data.user_means_paiementinactifs;
                      commit('SET_USER_MEANS_PAIEMENT',user_means_paiements)
                      commit('SET_USER_MEANS_INACTIF',user_means_paiementinactifs)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
         confirm({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/user_means_paiements/confirm',
                    data:data
                })
                    .then((response)=>{
                         let user_means_paiement_encours = response.data.user_means_paiement_encours;
                         let user_means_paiement_confirms = response.data.user_means_paiement_confirms;
                         commit('SET_USER_MEANS_ENCOURS',user_means_paiement_encours)
                         commit('SET_USER_MEANS_CONFIRM',user_means_paiement_confirms)
                         resolve(response);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getCities: state  => {
            return state.user_means_paiements
        },
    }
};
